export const isInWebView = () => {
  const { userAgent } = navigator;
  // Facebook, Instagram or other Webview (Tiktok, etc.)
  return /FBAN|FBAV|Instagram|Webview/i.test(userAgent);
};
